// extracted by mini-css-extract-plugin
export default {"sign":"zodiac_sign__qHJeY","sign_date":"zodiac_sign_date__GNHZS","description":"zodiac_description__gVLva","sign_image":"zodiac_sign_image__pK+vC"};